import smoothscroll from 'smoothscroll-polyfill';
import SmoothScroll from 'smooth-scroll';

class ScrollTo {
  constructor(selector) {
    const btns = document.querySelectorAll(selector);
    smoothscroll.polyfill();
    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        const to = document.querySelector(btn.getAttribute('data-scrollto'));
        to.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'start'
        });
      });
    });
  }
}

/*
 * The Best template's Contents card is sticky, so a link out of it has to put
 * its section on the card's own top edge -- the site-wide offset below is
 * measured from the viewport, which on that page drops the heading behind the
 * fixed header.
 *
 * The number is read off the card's computed `top` rather than written here,
 * so `_best-single.scss` stays the only place the sticky offset is decided and
 * the two cannot drift. It is a rem value, and the root font scales under
 * 1440, so resolving it at click time is also what keeps it right on a narrow
 * desktop. On mobile the card is `position: static` and there is nothing to
 * line up with, so the section only has to clear the header -- measured, since
 * that bar shrinks as the page scrolls.
 */
export const bestNavOffset = () => {
  const card = document.querySelector('.best-nav');

  if (!card) {
    return 0;
  }

  const style = window.getComputedStyle(card);

  if (style.position === 'sticky') {
    return parseFloat(style.top) || 0;
  }

  const header = document.querySelector('.header');

  // The sticky offset is the bar plus 2rem of air; keep the same gap here.
  return (header ? header.getBoundingClientRect().height : 0) + 20;
};

const scroll = new SmoothScroll('a[href*="#"]', {
  // header: '.header',
  offset: (anchor, toggle) => {
    if (toggle && toggle.classList.contains('best-nav__link')) {
      return bestNavOffset();
    }

    if (window.innerWidth < 768 || document.documentElement.clientWidth < 768) {
      return 30;
    }
    return 45;
  }
});

export default ScrollTo;
